import { render, staticRenderFns } from "./OrderDoctorSelector.vue?vue&type=template&id=4eaad98a&"
import script from "./OrderDoctorSelector.vue?vue&type=script&lang=js&"
export * from "./OrderDoctorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports